import React, { Fragment, useState, useEffect, useRef } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faShoppingCart, faWallet, faCalendar, faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import Header from './Header';
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import AddTopUp from './AddTopUp';
import AlertService from '../../../components/Alerts/alerts';
import DashboardService from "../dashboard.service";
import AuthService from "../../Authentication/auth.service";
import { useTranslation } from 'react-i18next';
import Alerts from "../../../components/Alerts/alerts";
import { Container, Grid, Card, CardContent, Typography, CardMedia, Button, Box, IconButton, Snackbar, Alert, FormGroup, FormControlLabel, Checkbox } from '@mui/material';

const CreditPage = () => {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [logo, setLogo] = useState(localStorage.getItem("system_logo"));
  const [branch, setBranch] = useState('');
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [showTopUp, setShowTopUp] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userData, setUser] = useState(null);

  const handleTopUpClick = () => {
    setShowTopUp(true);
  };

  const handleCloseTopUp = () => {
    setShowTopUp(false);
  };

  useEffect(() => {
    fetchTopups()
    // Simulated transaction data - replace with actual API call

    setTransactions([]);
  }, []);

  function logOut() {
    navigate("/user-login/customers");
    AuthService.logout();
    // window.location.reload();
  }

  const fetchTopups = () => {
    const userString = localStorage.getItem('user');
    const user = JSON.parse(userString);
    const userId = user['_id'];
    let data = {
      user_id: userId,
    }
    setLoading(true);
    DashboardService.GetTopUp(data).then((response) => {
      setLoading(false);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        let top_ups = response.data.data
        setTransactions(top_ups);
        setBalance(response.data.total)
      }
    }).catch((error) => {
      setLoading(false);
      const errContent = (error.response && error.response.data) || error.message || error.toString();
      if (errContent) {
        Alerts.swalErrorAlert(errContent);
      } else {
        Alerts.swalErrorAlert(t("Server Error, Please try again later."));
      }
    });
  };


  const styles = {
    creditPage: {
      fontFamily: 'Arial, sans-serif',
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    balanceSection: {
      background: 'linear-gradient(to bottom, #4a4a4a, #000000)',
      color: 'white',
      padding: '20px',
      borderRadius: '10px',
      textAlign: 'center',
    },
    walletIcon: {
      backgroundColor: '#f0e68c',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 auto 10px',
    },
    transactionsSection: {
      backgroundColor: '#f8f9fa',
      borderRadius: '10px',
      padding: '20px',
      marginTop: '20px',
    },
    topUp: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    topUpButton: {
      backgroundColor: '#000',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    filterDate: {
      position: 'relative',
      marginBottom: '20px',
    },
    filterInput: {
      width: '100%',
      padding: '10px',
      paddingRight: '30px',
      border: '1px solid #ccc',
      borderRadius: '5px',
    },
    calendarIcon: {
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    transactionsList: {
      listStyleType: 'none',
      padding: 0,
    },
    transactionItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 0',
      borderBottom: '1px solid #eee',
    },
    transactionInfo: {
      display: 'flex',
      flexDirection: 'column',
    },
    transactionType: {
      fontWeight: 'bold',
    },
    transactionDate: {
      color: '#666',
      fontSize: '0.9em',
    },
    transactionAmount: {
      fontWeight: 'bold',
    },
  };



  const FooterItem = ({ icon, text, to, onClick }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
      <Box
        onClick={() => {
          if (onClick) {
            onClick();
          } else if (to) {
            navigate(to);
          }
        }}
        sx={{
          textAlign: 'center',
          color: isActive ? '#3488A4' : '#888',
          fontSize: 'clamp(12px, 2vw, 14px)',
          cursor: 'pointer'
        }}
      >
        {icon}<br />{text}
      </Box>
    );
  };
  const SidebarTextItem = ({ text, to, color = 'black', onClick }) => {
    const isActive = location.pathname === to;
    return (
      <div
        onClick={() => {
          if (onClick) {
            onClick();
          } else if (to) {
            navigate(to);
          }
        }}
        style={{ margin: '10px 0' }}>
        <span style={{
          fontSize: '14px',
          color: isActive ? '#3488A4' : color,
        }}>{text}</span>
      </div>
    )
  };


  const SidebarItem = ({ icon, text, color = 'black', onClick, to }) => {
    const isActive = location.pathname === to;

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          margin: '10px 0',
          color: isActive ? '#3488A4' : color,
          cursor: 'pointer'
        }}
        onClick={() => {
          if (onClick) {
            onClick();
          } else if (to) {
            navigate(to);
          }
        }}
      >
        <span style={{ marginRight: '15px', fontSize: '20px' }}>{icon}</span>
        <span style={{ fontSize: '16px' }}>{text}</span>
      </div>
    );
  };
  const CartView = () => {
    navigate('/CartView')
  };

  const User_Profile = () => {
    navigate('/User_Profile')
  };

  const CustomerTopup = () => {
    navigate('/CustomerTopup')
  };

  const CustomerRewards = () => {
    navigate('/CustomerRewards')
  };

  const CustomerOrders = () => {
    navigate('/CustomerOrders')
  };

  return (
    <>
      <div style={{ backgroundColor: "black", minHeight: "100vh", display: "flex", justifyContent: "center" }}>
        <div style={{ width: "100%", maxWidth: "1300px", backgroundColor: "white", position: "relative" }}>
          <header style={{
            position: 'fixed',
            width: '100%',
            maxWidth: "1300px",
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            backgroundColor: 'white',
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 20px',
              margin: '0 auto',
              maxWidth: '100%',
            }}>
              <div style={{ border: '1px solid #3488A4', borderRadius: '5px', padding: '8px', fontSize: '24px', cursor: 'pointer' }} onClick={() => setSidebarOpen(true)}>≡</div>
              <img src={logo} alt="Logo" style={{ cursor: 'pointer', width: '120px', height: 'auto' }} />
              <div></div>
            </div>
          </header>



          {sidebarOpen && (
            <div className="slide-in" style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '80%',
              maxWidth: '300px',
              height: '100%',
              backgroundColor: 'white',
              zIndex: 1001,
              boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'auto'
            }}>
              <div style={{
                backgroundColor: '#3488A4',
                color: 'white',
                padding: '20px',
                position: 'relative'
              }}>
                <h2 style={{ margin: 0, fontSize: '24px' }}>{userData?.name || ''}</h2>
                <p style={{ margin: '5px 0 0 0', fontSize: '14px' }}>{userData?.email || ''}</p>
                <button onClick={() => setSidebarOpen(false)} style={{ position: 'absolute', top: '20px', right: '20px', background: 'none', border: 'none', fontSize: '24px', color: 'white' }}>
                  &gt;
                </button>
              </div>
              <div style={{ padding: '20px' }}>
                <SidebarItem
                  icon="🏠"
                  text="Home"
                  to="/Store"
                />
                <SidebarItem icon="📋" text="My Orders" onClick={() => { CustomerOrders() }} />
                <SidebarItem icon="💳" text="Credits" onClick={() => { CustomerTopup() }} />
                <SidebarItem icon="🛒" text="Cart" onClick={() => { CartView() }} />
                <SidebarItem icon="👤" text="Profile" onClick={() => { User_Profile() }} />
                <div style={{ backgroundColor: '#3488A4', padding: '10px', margin: '10px 0', borderRadius: '5px' }}>
                  <SidebarItem icon="⭐" text="Create App Shortcut" color="white" />
                </div>
                <SidebarItem icon="🌐" text="Switch Language" />
              </div>
              <div style={{ padding: '0 20px' }}>
                <SidebarTextItem text="Helps & FAQs" to="/term_of_use" />
                <SidebarTextItem text="Terms of Use" to="/term_of_use" />
                <SidebarTextItem text="Privacy Policy" to="/privacy_policy" />
                <SidebarTextItem text="Return Policy" to="/return_policy" />
                <SidebarTextItem text="Terms & Conditions" to="/terms_and_conditions" />
                <SidebarTextItem text="Newsroom" to="/news_room" />
                <SidebarTextItem text="NEW Page" to="/new_page" />
              </div>
              <div style={{ padding: '20px', marginTop: 'auto' }}>
                <button style={{
                  backgroundColor: '#3488A4',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  width: '100%',
                  fontSize: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                  onClick={logOut}>

                  <span style={{ marginRight: '10px' }}>↩</span> Logout
                </button>
              </div>
              <div style={{ padding: '10px 20px', borderTop: '1px solid #eee' }}>
                <p style={{ margin: 0, color: '#888', fontSize: '14px' }}>Version: 2.1</p>
              </div>
            </div>
          )}

          <TransitionGroup>
            <CSSTransition component="div" classNames="TabsAnimation"
              appear={true} timeout={0} enter={false} exit={false}>
              <div>
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <Header branch={branch} setBranch={setBranch} />
                  </div>
                </div>
                <div>

                  <header style={styles.header}>
                    {/* <FontAwesomeIcon icon={faBars} /> */}
                    <h1></h1>
                    <h1>My Credit</h1>
                    <h1></h1>
                    {/* <FontAwesomeIcon icon={faShoppingCart} /> */}
                  </header>

                  <div style={styles.balanceSection}>
                    <div style={styles.walletIcon}>
                      <FontAwesomeIcon icon={faWallet} />
                    </div>
                    <p>Balance</p>
                    <h2>{parseFloat(balance).toFixed(2)}</h2>
                  </div>

                  <div style={styles.transactionsSection}>
                    <div style={styles.topUp}>
                      <span>Top-up now</span>
                      <button style={styles.topUpButton} onClick={handleTopUpClick}>
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>

                    <h3>Transactions History</h3>

                    {/* <div style={styles.filterDate}>
                      <input type="text" placeholder="Filter Date" style={styles.filterInput} />
                      <FontAwesomeIcon icon={faCalendar} style={styles.calendarIcon} />
                    </div> */}

                    <ul style={styles.transactionsList}>
                      {transactions.map((transaction, index) => (
                        <li key={index} style={styles.transactionItem}>
                          <div style={styles.transactionInfo}>
                            <span style={styles.transactionType}>{transaction.type}</span>
                            <span style={styles.transactionDate}>{moment(transaction.date, 'YYYY-MM-DD HH:mm:ss').format('DD MMM, YYYY - HH:mm A')}</span>


                          </div>
                          <span style={{
                            ...styles.transactionAmount,
                            color: transaction.type === 'Topup' || 'Reward' ? 'green' : transaction.type === 'Order Cancelled' ? 'green' : 'red'
                          }}>
                            {parseFloat(transaction?.amount).toFixed(2)}
                            {transaction.type === 'Topup' || 'Reward' ? '↑' : transaction.type === 'Order Cancelled' ? '↑' : '↓'}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

              </div>
            </CSSTransition>
          </TransitionGroup>
          <footer className="slide-up" style={{
            position: 'fixed',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            maxWidth: "1300px",
            display: 'flex',
            justifyContent: 'space-around',
            backgroundColor: 'white',
            padding: '10px',
            boxShadow: '0 -2px 5px rgba(0,0,0,0.1)'
          }}>
            <FooterItem icon="🎁" text="Rewards" onClick={() => { CustomerRewards() }} />
            <FooterItem icon="🛒" text="Cart" onClick={() => { CartView() }} />
            <FooterItem icon="🏠" text="Home" to="/Store" />
            <FooterItem icon="📋" text="Orders" onClick={() => { CustomerOrders() }} />
            <FooterItem icon="👤" text="Profile" onClick={() => { User_Profile() }} />
          </footer>
        </div>
      </div>
      {showTopUp && <AddTopUp onClose={handleCloseTopUp} />}
    </>
  );
};

export default CreditPage;